var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64112 5.00024L3.05563 2.41475C2.66511 2.02423 2.58596 1.47021 2.87886 1.17732C3.17175 0.884424 3.72577 0.963569 4.11629 1.35409L6.94472 4.18252C7.18801 4.42581 7.31045 4.73256 7.29738 5.00009C7.31056 5.26769 7.18811 5.57457 6.94473 5.81795L4.11631 8.64637C3.72578 9.0369 3.17176 9.11604 2.87887 8.82315C2.58598 8.53026 2.66512 7.97624 3.05565 7.58571L5.64112 5.00024Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.9b420e121fa9b21df541c68bd2c250d0.svg";
export { ForwardRef as ReactComponent };